import { createBrowserRouter } from "react-router";
import { Layout } from "../components";
import {
  ComparePage,
  HammerPage,
  HistoryPage,
  LearnPage,
  ValidatePage,
} from "../pages";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        index: true,
        element: <ValidatePage />,
      },
      {
        path: "compare",
        element: <ComparePage />,
      },
      {
        path: "history",
        element: <HistoryPage />,
      },
      {
        path: "learn",
        element: <LearnPage />,
      },
      {
        path: "hammer",
        element: <HammerPage />,
      },
    ],
  },
]);
